import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AiUsageSummaryView } from "@/components/settings/ai-usage/AiUsageSummaryView";
import { AiUsageLogView } from "@/components/settings/ai-usage/AiUsageLogView";

// The active view lives in `?view` so a view is linkable and Back steps between them. Anything
// other than `logs` -- absent, empty, unknown -- is the dashboard.
export function AIUsageTab() {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("view") === "logs" ? "logs" : "dashboard";

  const onViewChange = (next: string) => {
    const params = new URLSearchParams(searchParams);
    params.set("view", next);
    // A push, never `replace`: Back returns to the previous view, and `tab` survives.
    setSearchParams(params);
  };

  return (
    <Tabs value={view} onValueChange={onViewChange} className="space-y-6">
      <TabsList className="bg-muted/50 rounded-lg p-1 h-auto">
        <TabsTrigger value="dashboard" className="text-sm rounded-md px-4 py-1.5">
          Dashboard
        </TabsTrigger>
        <TabsTrigger value="logs" className="text-sm rounded-md px-4 py-1.5">
          Logs
        </TabsTrigger>
      </TabsList>
      <TabsContent value="dashboard" className="mt-0">
        <AiUsageSummaryView />
      </TabsContent>
      <TabsContent value="logs" className="mt-0">
        <AiUsageLogView />
      </TabsContent>
    </Tabs>
  );
}
